export enum AppStateNameEnum {

    feature_core = 'feature_core',
    feature_indication = 'feature_indication',
    feature_indication_basic = 'feature_indication_basic',
    feature_consent_chapter = 'feature_consent_chapter',
    feature_consent_chapter_basic = 'feature_consent_chapter_basic',
    feature_consent_use_case = 'feature_consent_use_case',
    feature_consent_use_case_basic = 'feature_consent_use_case_basic',
    feature_consent = 'feature_consent',
    feature_consent_basic = 'feature_consent_basic',
    feature_secured = 'feature_secured',
    feature_review = 'feature_review',
    feature_wizard = 'feature_wizard',
    feature_users = 'feature_users',
    feature_cms = 'feature_cms',
    feature_medication = 'feature_medication',

}
